import { LookupType } from './lookups-query-v2.types';

export const LookupsURLV2 = {
  [LookupType.companies]: '/api/v2/lookups/companies',
  [LookupType.payrollServiceProviders]: '/api/v2/lookups/payrollServiceProviders',
  [LookupType.payrollServiceProviderUsers]: '/api/v2/lookups/payrollServiceProviderUsers',
  [LookupType.businessUnits]: '/api/v2/lookups/businessUnits',
};
